import React, { useCallback, useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { ParticipantFieldCategory } from '@app/api';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import {
  TypeDataSource,
  TypeRowSelection,
} from '@inovua/reactdatagrid-community/types';
import moment from 'moment-timezone';
import { useParticipantColumns } from './hooks/useParticipantColumns';
import { filterTypes, useDefaultParticipantFilters } from './hooks/useFiters';
window.moment = moment;

const useStyles = createUseStyles((theme: Theme) => ({}));

interface Props {
  panelId: string;
  selected: string[];
  onSelectedChange: (selected: string[]) => void;
  dataSource: TypeDataSource;
}

type TypeOnSelectionChangeArg = {
  selected: TypeRowSelection;
  data?: object;
  unselected?: TypeRowSelection;
  originalData?: TypeDataSource;
};

const categories = Object.values(ParticipantFieldCategory).map((category) => ({
  name: category,
  header: category,
}));

const gridStyle = { flex: 1 };

export const PanelTable = ({
  panelId,
  selected,
  onSelectedChange,
  dataSource,
}: Props) => {
  const classes = useStyles();

  const columns = useParticipantColumns(panelId);
  const defaultFilterValue = useDefaultParticipantFilters();

  const onSelectionChange = useCallback(
    (config: TypeOnSelectionChangeArg) => {
      if (config.selected === true && Array.isArray(config.data)) {
        onSelectedChange(config.data.map((item) => item.id));
      } else if (!config.selected) {
        onSelectedChange([]);
      } else if (typeof config.selected === 'string') {
        onSelectedChange([config.selected]);
      } else {
        onSelectedChange(Object.keys(config.selected));
      }
    },
    [onSelectedChange],
  );

  const selection = useMemo(() => {
    return selected.reduce((acc, id) => {
      acc[id] = true;
      return acc;
    }, {} as Record<string, boolean>);
  }, [selected]);

  if (!defaultFilterValue) {
    return null;
  }
  return (
    <ReactDataGrid
      style={gridStyle}
      idProperty="id"
      columns={columns}
      dataSource={dataSource}
      pagination
      defaultFilterValue={defaultFilterValue}
      checkboxColumn={true}
      enableSelection
      multiSelect
      onSelectionChange={onSelectionChange}
      checkboxOnlyRowSelect
      selected={selection}
      showColumnMenuSortOptions
      showColumnMenuLockOptions={false}
      showColumnMenuFilterOptions
      showColumnMenuGroupOptions={false}
      reorderColumns={false}
      groups={categories}
      filterTypes={filterTypes}
    />
  );
};
